export function convertServicesMapping(services) {
    return services?.reduce((obj, service) => {
        obj[service?.id] = service;
        return obj;
    }, {});
}
